import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import AssetSystem from '../../../../systems/AssetSystem';

const useReduxAssetSystem = () => {
	const dispatch = useDispatch();
	return useMemo( () => new AssetSystem( dispatch ), [] );
};

export default useReduxAssetSystem;
